<template>
  <div>
    <h1>Plaid Items</h1>
    <p>Here are your plaid items</p>
  </div>
</template>

<script>
export default {
  name: 'items'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Items.vue?48dd6223